<template>
    <b-button
        v-if="description"
        v-b-tooltip.hover.focus="{title: description, customClass: 'telegram-group-help-tooltip'}"
        type="button"
        variant="link"
        size="sm"
        class="telegram-group-help"
        :aria-label="label"
        @click.stop="$event.currentTarget.focus()"
    ><i class="far fa-question-circle" aria-hidden="true"/></b-button>
</template>

<script>
const descriptions = {
    additional: 'У каждой дополнительной группы — свой состав: можно собрать только нужных специалистов, например без руководителей компании. Рабочие детали остаются в группе по объекту, не теряются в личных чатах и не перегружают основную группу.',
    itr: 'Технические вопросы, сложные узлы и проблемы объекта — в кругу ИТР. Состав выбираете сами: можно обсудить детали только со специалистами, без руководителей компании. Решения остаются в группе объекта, а основная группа — для общих вопросов.',
    supply: 'Материалы, заявки, сроки поставок и замены — с теми, кто отвечает за снабжение объекта. Соберите свой состав, при необходимости без руководителей компании. Договорённости не теряются в личных чатах и не перегружают основную группу.',
    mechanics: 'Поломки, ремонт, запчасти и готовность техники на объекте — в кругу механиков и нужных специалистов. Состав задаёте отдельно, можно без руководителей компании. Вся история по объекту под рукой, без лишней переписки в основной группе.',
    custom: 'Отдельная тема по объекту? Создайте группу со своим названием и пригласите только нужных людей, при необходимости без руководителей компании. Обсуждение останется в группе по объекту и не потеряется в личных чатах.'
};
const labels = {additional: 'Зачем нужны дополнительные группы', itr: 'Зачем нужна группа ИТР', supply: 'Зачем нужна группа Снабжение', mechanics: 'Зачем нужна группа Механики', custom: 'Зачем нужна произвольная группа'};

export default {
    props: {kind: {type: String, default: 'additional'}},
    computed: {
        helpKind() { return this.kind.startsWith('custom_') ? 'custom' : this.kind; },
        description() { return descriptions[this.helpKind] || ''; },
        label() { return labels[this.helpKind] || 'Назначение группы'; }
    }
};
</script>

<style scoped>
.telegram-group-help {display: inline-flex; align-items: center; justify-content: center; flex: 0 0 auto; width: 26px; height: 26px; padding: 0; margin-left: 2px; color: #6c757d; font-size: 14px; vertical-align: middle;}
.telegram-group-help:hover, .telegram-group-help:focus {color: #495057; text-decoration: none;}
@media (pointer: coarse) {
    .telegram-group-help {width: 32px; height: 32px;}
}
</style>
<style>
.telegram-group-help-tooltip .tooltip-inner {max-width: 320px; text-align: left;}
@media (max-width: 575.98px) {
    .telegram-group-help-tooltip .tooltip-inner {max-width: calc(100vw - 32px);}
}
</style>
